const options = {
  rootMargin: '0px 0px -0px 0px',
  threshold: 0.5,
};

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    } else {
      entry.target.classList.remove('is-visible');
    }
  });
}, options);

const contentSections = document.querySelectorAll(
  '.content, .decouvrir, .financer__content figcaption, .elementor-element'
);
contentSections.forEach((section) => {
  observer.observe(section);
});

window.addEventListener('scroll', onScroll);
window.addEventListener('beforeunload', () => {
  window.removeEventListener('scroll', onScroll);
});

function onScroll() {
  const scrollTop = window.pageYOffset;
  const parallaxElements = document.querySelectorAll(
    '.content__description picture>div, .decouvrir__imgs>div, .financer__imgs>div, .parallax'
  );
  parallaxElements.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      const y = (rect.top - window.innerHeight / 2) * 0.1;
      el.style.transform = `translateY(${y}px)`;
    }
  });
}

// show btn scroll to top when scroll down of half page

function scrollToTop() {
  const btnScrollToTop = document.querySelector('.scrollTop');
  if (window.scrollY > window.innerHeight / 2) {
    btnScrollToTop.classList.add('active');
  } else {
    btnScrollToTop.classList.remove('active');
  }
}
window.addEventListener('load', scrollToTop);
window.addEventListener('scroll', scrollToTop);

window.addEventListener('DOMContentLoaded', () => {
  AOS.init({ once: true });
});

//menu mobile
window.addEventListener('load', () => {
  const menu = document.querySelector('.menu__item svg');

  menu.addEventListener('click', () => {
    const innerMenu = document.querySelector('.menu__item>div');
    innerMenu.classList.toggle('active');
  });
});
